import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { I18nProvider } from "@/contexts/I18nContext";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "sonner";

import PublicLayout from "@/components/PublicLayout";
import AuthCallback from "@/components/AuthCallback";
import AdminProtectedRoute from "@/components/AdminProtectedRoute";
import GAListener from "@/components/GAListener";

import Home from "@/pages/Home";
import About from "@/pages/About";
import ExportCommodities from "@/pages/ExportCommodities";
import ImportProducts from "@/pages/ImportProducts";
import ProductDetail from "@/pages/ProductDetail";
import TradeServices from "@/pages/TradeServices";
import CatalogueCenter from "@/pages/CatalogueCenter";
import News from "@/pages/News";
import NewsDetail from "@/pages/NewsDetail";
import Contact from "@/pages/Contact";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminServices from "@/pages/admin/AdminServices";
import AdminCatalogues from "@/pages/admin/AdminCatalogues";
import AdminNews from "@/pages/admin/AdminNews";
import AdminInquiries from "@/pages/admin/AdminInquiries";
import AdminCatalogueRequests from "@/pages/admin/AdminCatalogueRequests";
import AdminTeam from "@/pages/admin/AdminTeam";
import AdminSettings from "@/pages/admin/AdminSettings";

// Synchronously detect OAuth callback (race-condition safe)
function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <GAListener />
      <Routes>
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/export-commodities" element={<ExportCommodities />} />
        <Route path="/import-products" element={<ImportProducts />} />
        <Route path="/products/:id" element={<ProductDetail />} />
        <Route path="/services" element={<TradeServices />} />
        <Route path="/catalogue" element={<CatalogueCenter />} />
        <Route path="/news" element={<News />} />
        <Route path="/news/:slug" element={<NewsDetail />} />
        <Route path="/contact" element={<Contact />} />
      </Route>
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route
        path="/admin"
        element={
          <AdminProtectedRoute>
            <AdminLayout />
          </AdminProtectedRoute>
        }
      >
        <Route index element={<AdminDashboard />} />
        <Route path="products" element={<AdminProducts />} />
        <Route path="categories" element={<AdminCategories />} />
        <Route path="services" element={<AdminServices />} />
        <Route path="catalogues" element={<AdminCatalogues />} />
        <Route path="news" element={<AdminNews />} />
        <Route path="inquiries" element={<AdminInquiries />} />
        <Route path="catalogue-requests" element={<AdminCatalogueRequests />} />
        <Route path="team" element={<AdminTeam />} />
        <Route path="settings" element={<AdminSettings />} />
      </Route>
    </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <AuthProvider>
          <BrowserRouter>
            <AppRouter />
            <Toaster position="top-right" richColors />
          </BrowserRouter>
        </AuthProvider>
      </I18nProvider>
    </div>
  );
}

export default App;
